<div class="login-card login-dark">
    <div>
        <div>
            <a class="logo"  routerLink='/'>
<!--                <img class="img-fluid for-light" src="../../../../../assets/images/logo/logo.png" alt="looginpage">-->
                <img class="image-logo for-light" src="../../../../../assets/images/logo/logo.png" alt="looginpage">
                <img class="img-fluid for-dark" src="../../../../../assets/images/logo/logo_dark.png" alt="looginpage">
            </a>
        </div>

        <div class="login-main">
            <h4>Choisissez votre type de compte</h4>

            <div class="row  mb-3 mt-4">
                <div class="col-md-6 d-flex align-items-center justify-content-center">
                    <div class="form-check">
                        <input class="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault1" (click)="checkTypeUser(candidat)" checked>
                        <label class="form-check-label fs-6" for="flexRadioDefault1">
                            Candidat
                        </label>
                    </div>
                </div>
                <div class="col-md-6 d-flex align-items-center justify-content-center">
                    <div class="form-check">
                        <input class="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault2" (click)="checkTypeUser(structure)">
                        <label class="form-check-label fs-6" for="flexRadioDefault2">
                            Structure
                        </label>
                    </div>
                </div>
            </div>

            <a [routerLink]="['volontaire']" [queryParams]="{typeUserData: typeUser}" class="btn btn-primary float-end"  type="submit" (click)="checkTypeUser(structure)">Suivant <i class="fa fa-arrow-right"></i></a>
        </div>
    </div>
</div>
